import styled from 'styled-components'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAxios } from '@/context/axiosContext'
import { useEffect, useState } from 'react'
import {
  getBadgeLabel,
  GetBoardData,
  withDrawnCumtomer,
} from '@/pages/board/boardItem'
import { BoardTitle } from '../board/mainBoard'
import { BlogListItem, removeHtmlTags } from '@/pages/blog/blogItem'
import GGOOLLFF from '@/assets/images/GGOOLLFF.png'
import commonUtils from '@/utils/commonUtils'
import './mainBlog.css'
import { useResponsive } from '@/hooks/useResponsive'

export const MainBlog = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const axios = useAxios()
  const [page, setPage] = useState(location.state?.page ?? 1)
  const [blogList, setBlogList] = useState<BlogListItem[]>([])
  const [srchData, setSrchData] = useState({
    srchOpt: location.state?.srchOpt || '01',
    srchStr: location.state?.srchStr || '',
  })
  const filePath = process.env.REACT_APP_BASE_URL + '/upload'
  const { isMobile, isTablet, isDesktop } = useResponsive()
  useEffect(() => {
    getBlogBoardList()
  }, [])

  const getBlogBoardList = async () => {
    try {
      const data: GetBoardData = {
        srchOpt: srchData.srchOpt,
        srchStr: srchData.srchStr,
        page: page,
      }

      const response = await axios.get(`/blog/list`, {
        headers: { 'Cache-Control': 'no-cache' },
        params: { ...data },
      })

      const { blogList } = response.data.data
      if (Array.isArray(blogList)) {
        setBlogList(blogList)
      }
    } catch (err: any) {
      console.error('Error fetching List:', err)
    }
  }

  const handleDetailView = (nttSn: number) => {
    window.scrollTo(0, 0)
    navigate(`/blog/detail?nttSn=${nttSn}`)
  }

  const moveBlogBoard = () => {
    window.scrollTo(0, 0)
    navigate(`/blog`)
  }

  return (
    <>
      <MainBlogWrapper>
        <BoardTitle onClick={moveBlogBoard}>
          {'소통'}
          <div
            style={{
              cursor: 'pointer',
              fontSize: '13px',
              color: '#888888',
              fontWeight: 'normal',
            }}
            onClick={moveBlogBoard}
          >
            {'더보기'}
          </div>
        </BoardTitle>
        <div className="blog-board">
          {blogList.length > 0 ? (
            blogList.slice(0, 4).map((item) => (
              <div
                className="blog-item"
                key={item.nttSn}
                onClick={() => handleDetailView(item.nttSn)}
              >
                {item.thumbnailUrl ? (
                  <img
                    src={filePath + item.thumbnailUrl}
                    className="blog-image"
                    alt="thumbnail"
                    onError={(e) => {
                      e.currentTarget.onerror = null
                      e.currentTarget.src = GGOOLLFF
                    }}
                  />
                ) : (
                  <img
                    src={GGOOLLFF}
                    className="blog-image"
                    alt="이미지 제목"
                  />
                )}
                <div className="blog-divider" />
                <div className="blog-title-with-count">
                  <div
                    className="blog-title"
                    title={item.nttSj}
                  >{`${removeHtmlTags(item.nttSj)}`}</div>
                  <div className="blog-answer-count">{`${item.answerCnt !== 0 ? ` [${item.answerCnt}]` : ''}`}</div>
                </div>
                <div className="blog-post-meta">
                  {!isMobile && (
                    <>
                      <div className="blog-author-section">
                        <span>
                          {item.withDrawYn
                            ? withDrawnCumtomer.name
                            : item?.nickName}
                        </span>
                      </div>
                      <div className="blog-post-meta-divider" />
                    </>
                  )}
                  <div className="blog-post-meta-item">
                    {item?.regDate
                      ? commonUtils.formatDate(item.regDate, false)
                      : ''}
                  </div>
                  <div className="blog-post-meta-divider" />
                  <div className="blog-post-meta-item">
                    조회 : {item?.readngCnt}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="blog-no-results">
              <img src={GGOOLLFF} width={'200px'} />
              <div>아직 등록된 내용이 없거나, 찾으시는 결과가 없어요.</div>
            </div>
          )}
        </div>
        {/* <StyledTable
          style={{
            tableLayout: 'fixed',
            width: '100%',
            marginTop: '2px',
            marginBottom: '0px',
          }}
        >
          <tbody style={{ fontSize: '14px' }}>
            {blogList.length > 0 ? (
              <>
                {blogList.slice(0, 4).map((item) => (
                  <tr key={item.nttSn}>
                    <StyledTD
                      style={{ width: 'auto' }}
                      onClick={() => handleDetailView(item.nttSn)}
                    >
                      <Badge color="neverbe">
                        {getBadgeLabel(item.bbsSj ? item?.bbsSj : '')}
                      </Badge>
                      &nbsp;&nbsp;
                      {item.nttSj}
                      {item.answerCnt ? ` [${item.answerCnt}]` : ''}
                      &nbsp;&nbsp;
                    </StyledTD>
                    <StyledTD style={{ width: '100px' }}>
                      {item.nickName}
                    </StyledTD>
                  </tr>
                ))}
                {Array.from({ length: 4 - blogList.length }).map((_, i) => (
                  <tr key={`empty-${i}`}>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <StyledTD colSpan={2} style={{ padding: '20px 10px' }}>
                  아직 등록된 문의가 없습니다. 첫 번째로 문의를 남겨보세요!
                </StyledTD>
              </tr>
            )}
          </tbody>
        </StyledTable> */}
      </MainBlogWrapper>
    </>
  )
}

export const MainBlogWrapper = styled.div`
  border: 1px solid #ddd;
  padding: 12px 15px 10px 15px;
  border-radius: 8px;
  width: 100%;
  border-bottom: 1px solid #ddd; /* 테두리 유지 */
  box-sizing: border-box; /* padding이 border에 포함되도록 설정 */
  flex: 1; /* 남는 높이 없게끔 가져가기 */
`
